import { ApiGetRequest } from '../../api';

export const state = {
  data: {
    total_av: 0,
    loading_av: false,
    total_dm: 0,
    loading_dm: false,
    total_av_na: 0,
    loading_av_na: false,
    total_dm_na: 0,
    loading_dm_na: false,
    total_stock: 0,
    loading_stock: false,
    total_submission: 0,
    loading_submission: false,
    total_repair: 0,
    loading_repair: false,
    total_pti: 0,
    loading_pti: false,
    loading_chart: false,
    today_container_in: 0,
    today_container_out: 0,
    last_month_stock: 0,
    today_month_stock: 0,
    chartData: {
      series: [
        {
          name: 'Container In',
          data: [],
        },
        {
          name: 'Container Out',
          data: [],
        },
        {
          name: 'Repair',
          data: [],
        },
        {
          name: 'PTI',
          data: [],
        },
      ],
      chartoptions: {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#f1b44c', '#f44336', '#03a9f4'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
      },
    },
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getTotalByStatus({ commit }, payload = null) {
    commit('changeDashboard', {
      [`loading_${payload.status.replace('-', '_')}`]: true,
    });

    let result = await ApiGetRequest(
      `opr/dashboard/status/${payload.status ? payload.status : 'av'}`
    );
    commit('changeDashboard', {
      [`total_${payload.status.replace('-', '_')}`]: result.data.error
        ? 0
        : result.data.object,
      [`loading_${payload.status.replace('-', '_')}`]: false,
    });

    return !result.error ? true : false;
  },

  async getTotalByStock({ commit }) {
    commit('changeDashboard', {
      loading_stock: true,
    });

    let result = await ApiGetRequest(`opr/dashboard/stock`);
    commit('changeDashboard', {
      total_stock: result.data.error ? 0 : result.data.object,
      loading_stock: false,
    });

    return !result.error ? true : false;
  },

  async getTotalSubmission({ commit }) {
    commit('changeDashboard', {
      loading_submission: true,
    });

    let result = await ApiGetRequest(`opr/dashboard/submission`);
    commit('changeDashboard', {
      total_submission: result.data.error ? 0 : result.data.object,
      loading_submission: false,
    });

    return !result.error ? true : false;
  },

  async getTotalRepair({ commit }) {
    commit('changeDashboard', {
      loading_repair: true,
    });

    let result = await ApiGetRequest(`opr/dashboard/repair`);
    commit('changeDashboard', {
      total_repair: result.data.error ? 0 : result.data.object,
      loading_repair: false,
    });

    return !result.error ? true : false;
  },

  async getTotalPti({ commit }) {
    commit('changeDashboard', {
      loading_pti: true,
    });

    let result = await ApiGetRequest(`opr/dashboard/pti`);
    commit('changeDashboard', {
      total_pti: result.data.error ? 0 : result.data.object,
      loading_pti: false,
    });

    return !result.error ? true : false;
  },

  async getChartDashboard({ commit, state }) {
    commit('changeDashboard', {
      loading_chart: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/dashboard/chart`);
    commit('changeDashboard', {
      today_container_in: !result.error
        ? result.data.object.today_container_in
        : 0,
      today_container_out: !result.error
        ? result.data.object.today_container_out
        : 0,
      last_month_stock: !result.error ? result.data.object.last_month_stock : 0,
      today_month_stock: !result.error
        ? result.data.object.today_month_stock
        : 0,
      chartData: {
        ...data.chartData,
        series: [
          {
            name: 'Container In',
            data: !result.error ? result.data.object.container_in : [],
          },
          {
            name: 'Container Out',
            data: !result.error ? result.data.object.container_out : [],
          },
          {
            name: 'Repair',
            data: !result.error ? result.data.object.container_repair : [],
          },
          {
            name: 'PTI',
            data: !result.error ? result.data.object.container_pti : [],
          },
        ],
      },
      loading_chart: false,
    });

    return !result.error ? true : false;
  },
};
